<template>
  <div class="container">
    <div class="left">
      <img src="~@/assets/logo.svg" class="logo" alt="logo" @click="() => goBack()" />
      <span class="button">
        <a-button
          size="large"
          type="danger"
          shape="round"
          class="button-color"
          @click="() => downloadExe()"
        >
          应用下载地址
        </a-button>
      </span>
    </div>
    <div class="main">
      <span class="text">美丽起来，从现在</span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted } from 'vue';
import { default as router } from '@/router';

export default defineComponent({
  name: 'Download',
  setup() {
    onMounted(() => {
      document.body.classList.add('otherLayout');
    });
    onUnmounted(() => {
      document.body.classList.remove('otherLayout');
    });
    const downloadExe = () => {
      window.open(
        'https://dfs-mj.oss-cn-beijing.aliyuncs.com/mj-client-setup.exe?' + new Date().getTime(),
        '_blank',
      );
    };
    const goBack = () => {
      router.back();
    };
    return {
      downloadExe,
      goBack,
    };
  },
});
</script>

<style lang="less" scoped>
#otherLayout.other-layout-wrapper {
  height: 100%;

  &.mobile {
    .container {
      .main {
        width: 98%;
        max-width: 368px;
      }
    }
  }
  .container {
    position: relative;
    width: 100%;
    min-height: 100%;
    padding: 0 0 144px;
    background-image: url(~@/assets/background.svg);
    background-repeat: no-repeat;
    background-position: center 110px;
    background-size: 100%;

    a {
      text-decoration: none;
    }

    .left {
      text-align: left;
      .logo {
        height: 90px;
        margin-top: 17px;
        margin-right: 16px;
        padding-left: 25px;
        vertical-align: top;
        border-style: none;
      }
      .button {
        float: right;
        padding-top: 30px;
        padding-right: 90px;
      }
    }
    .main {
      width: 480px;
      min-width: 260px;
      margin: 0 auto;
      padding-top: 310px;
      .text {
        font-size: 60px;
        font-family: STXingkai, serif;
      }
    }

    .footer {
      position: absolute;
      bottom: 0;
      width: 100%;
      margin: 48px 0 24px;
      padding: 0 16px;
      text-align: center;

      .links {
        margin-bottom: 8px;
        font-size: 14px;
        a {
          color: @text-color-secondary;
          transition: all 0.3s;
          &:not(:last-child) {
            margin-right: 40px;
          }
        }
      }
      .copyright {
        color: @text-color-secondary;
        font-size: 14px;
      }
    }
  }
}
.button-color {
  height: 50px;
  padding: 0 40px;
  color: #fff;
  font-weight: 500;
  font-size: 25px;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  background-color: #ec4563;
  border-color: #ec4563;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}
</style>
